import { BrowserMiradorRouting } from '@aipb/browser-mirador/shared/routing';
import { BrowserRouting } from '@aipb/browser/shared/routing';
import { CatalogRouting } from '@aipb/catalog/shared/routing';
import { ConfigViewerRouting } from '@aipb/config-viewer/shared/routing';
import { DynamicGalleryRouting } from '@aipb/dynamic-gallery/shared/routing';
import { AppIdentifier } from '@aipb/env/model';
import { ExplorerRouting } from '@aipb/explorer/shared/routing';
import { FulltextRouting } from '@aipb/fulltext/shared/routing';
// eslint-disable-next-line
import { CustomerConfigEditorRouting } from '@aipb/gulliver/customer-config-editor/routing';
import { KeycloakManagerRouting } from '@aipb/keycloak-manager/shared/routing';
import { LanaRouting } from '@aipb/lana/shared/routing';
import { MercRouting } from '@aipb/merc/shared/routing';
import { PersonalContentRouting } from '@aipb/personal-content/shared/routing';
import { ReportTesterRouting } from '@aipb/report-tester/shared/routing';
import { ZipManagerRouting } from '@aipb/zip-manager/shared/routing';
import { Routes } from '@angular/router';
import { ApplicationAuthGuard } from './auth.guard';
import { LoginComponent, NotAuthorizedComponent, NotFoundComponent } from './pages';

const standardRoutes: Routes = [
  {
    path: '',
    redirectTo: CatalogRouting.APP_ROUTE,
    pathMatch: 'full'
  },
  {
    path: CatalogRouting.APP_ROUTE,
    loadChildren: () => import('@aipb/catalog/app').then((m) => m.CatalogRoutes),
    canActivate: [ApplicationAuthGuard]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'not-authorized',
    component: NotAuthorizedComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

export function generateRoutes(apps: AppIdentifier[]): Routes {
  const routes: Routes = [];

  const applications = apps;

  if (applications.includes('browser')) {
    routes.push({
      path: BrowserRouting.APP_ROUTE,
      loadChildren: () => import('@aipb/browser/app').then((m) => m.BrowserRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  if (applications.includes('browser-mirador')) {
    routes.push({
      path: BrowserMiradorRouting.APP_ROUTE,
      loadChildren: () => import('@aipb/browser-mirador/app').then((m) => m.BrowserMiradorRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  if (applications.includes('config-viewer')) {
    routes.push({
      path: ConfigViewerRouting.APP_ROUTE,
      loadChildren: () => import('@aipb/config-viewer/app').then((m) => m.ConfigViewerRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  if (applications.includes('customer-config-editor')) {
    routes.push({
      path: CustomerConfigEditorRouting.APP_ROUTE,
      // eslint-disable-next-line
      loadChildren: () => import('@aipb/gulliver/customer-config-editor/app').then((m) => m.CustomerConfigEditorRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  if (applications.includes('dynamic-gallery')) {
    routes.push({
      path: DynamicGalleryRouting.APP_ROUTE,
      loadChildren: () => import('@aipb/dynamic-gallery/app').then((m) => m.DynamicGalleryRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  if (applications.includes('explorer')) {
    routes.push({
      path: ExplorerRouting.APP_ROUTE,
      loadChildren: () => import('@aipb/explorer/app').then((m) => m.ExplorerRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  if (applications.includes('fulltext')) {
    routes.push({
      path: FulltextRouting.APP_ROUTE,
      loadChildren: () => import('@aipb/fulltext/app').then((m) => m.FulltextRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  if (applications.includes('keycloak-manager')) {
    routes.push({
      path: KeycloakManagerRouting.APP_ROUTE,
      loadChildren: () => import('@aipb/keycloak-manager/app').then((m) => m.KeycloakManagerRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  if (applications.includes('lana')) {
    routes.push({
      path: LanaRouting.APP_ROUTE,
      loadChildren: () => import('@aipb/lana/app').then((m) => m.LanaRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  if (applications.includes('merc')) {
    routes.push({
      path: MercRouting.APP_ROUTE,
      loadChildren: () => import('@aipb/merc/app').then((m) => m.MercRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  if (applications.includes('personal-content')) {
    routes.push({
      path: PersonalContentRouting.APP_ROUTE,
      loadChildren: () => import('@aipb/personal-content/app').then((m) => m.PersonalContentRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  if (applications.includes('report-tester')) {
    routes.push({
      path: ReportTesterRouting.APP_ROUTE,
      loadChildren: () => import('@aipb/report-tester/app').then((m) => m.ReportTesterRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  if (applications.includes('zip-manager')) {
    routes.push({
      path: ZipManagerRouting.APP_ROUTE,
      loadChildren: () => import('@aipb/zip-manager/app').then((m) => m.ZipManagerRoutes),
      canActivate: [ApplicationAuthGuard]
    });
  }

  return [...routes, ...standardRoutes];
}
